<template>
  <div>
    <BaseModalHeader>
      <BaseHeading :semantic-level="2" :display-level="1">
        {{ title }}
      </BaseHeading>
    </BaseModalHeader>
    <BaseModalContent :class="$style.fullWidth">
      <div :class="$style.embeddedVideo">
        <iframe :src="source" />
      </div>
      <Spacer :mt="4" />
      <BaseText type="bold" :class="$style.indent">
        {{ description }}
      </BaseText>
      <BaseList :class="$style.indent">
        <BaseListItem v-for="(step, i) in steps" :key="i" ordered>
          {{ step }}
        </BaseListItem>
      </BaseList>
    </BaseModalContent>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Video } from '~/terminierungsportal/types/appointmentTypes'
import { useAppointmentStore } from '~/terminierungsportal/stores/appointment'
import BaseModalHeader from '~/base/components/modal/ModalHeader.vue'
import BaseHeading from '~/base/components/heading/Heading.vue'
import BaseModalContent from '~/base/components/modal/ModalContent.vue'
import Spacer from '~/base/components/spacer/Spacer.vue'
import BaseText from '~/base/components/text/Text.vue'
import BaseList from '~/base/components/list/List.vue'
import BaseListItem from '~/base/components/list/ListItem.vue'

const appointmentStore = useAppointmentStore()
const props = defineProps({ active: { type: Boolean } })

const video = computed((): Video | null => {
  return appointmentStore.appointment.video
})

const description = computed((): string | undefined => {
  return video.value?.description
})

const steps = computed((): string[] | undefined => {
  return video.value?.steps
})

const title = computed((): string | undefined => {
  return video.value?.title
})

const source = computed((): string | undefined => {
  return props.active
    ? `https://www.youtube.com/embed/${video.value?.videoId}?rel=0`
    : ''
})
</script>

<style module>
.fullWidth {
  width: calc(100% + 64px);
  margin-left: -22px;
  padding-top: 0;
}

.embeddedVideo {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;

  iframe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  @media screen and(min-width: 1025px) {
    min-width: 600px
  }
}

.indent {
  padding: 0 20px;
}
</style>
